module.exports = __webpack_public_path__ + "static/media/9-4.9cdfa534.mp3";